import React from "react"
import { Modal, Form } from "react-bootstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import PrimaryButton from "../../components/subComponents/PrimaryButton"
import { toast } from "react-toastify"
import { request } from "../../services/request"
import { SensorsListData } from "../../services/authinterface"

type Props = {
  show: boolean
  onClose: () => void
  sensorData : SensorsListData | null
  fetchSensorsData : any
}

function SensorModel({ show, onClose, sensorData, fetchSensorsData }: Props) {
  const validationSchema = Yup.object().shape({
    device_id: Yup.string().required("Device ID is required"),
  })

  const formik = useFormik({
    initialValues: {
        device_id: sensorData?.sensor_id || "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        const payload = {
            newSensorId: values.device_id,
            oldSensorId :sensorData?.sensor_id
        }
        const response = await request({
          url: `/adminCommon/updateSensorID`,
          method: "PATCH",
          data: payload,
        })
        if (response.success) {
          toast.success(response.message)
          onClose()
          formik.resetForm()
          fetchSensorsData()
        } else {
          toast.error(response.message)
        }
      } catch (error: any) {
        toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
      }
    },
  })

  const { setFieldValue } = formik;

  React.useEffect(() => {
    if (!sensorData) return;
    setFieldValue("device_id", sensorData?.sensor_id || "")
  }, [sensorData, setFieldValue])

  return (
    <Modal
      className='comman-modal'
      show={show}
      onHide={() => {
        onClose()
        formik.resetForm()
      }}
      centered
    >
      <Form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton className='comman-modal-header'>
          <Modal.Title className='comman-modal-title'>Device</Modal.Title>
        </Modal.Header>
        <Modal.Body className='comman-modal-body'>

          <div className='login-input-section input-section mb-3'>
            <div>
              <label>
                Device ID{" "}
              </label>
            </div>
            <Form.Control
              type='text'
              name='device_id'
              placeholder='Please Enter Device ID'
              value={formik.values.device_id}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              isInvalid={!!formik.errors.device_id && formik.touched.device_id}
            />
            <span className='text-red-500 text-xs'>{formik.errors.device_id}</span>
          </div>

          <PrimaryButton type='submit' label='Update' className='editFormButton' />
        </Modal.Body>
      </Form>
    </Modal>
  )
}

export default SensorModel
